import { MarkerType } from '@xyflow/react';
import { createContext } from 'react';
export const defaultEntityNetworkSchematicContext = {
    handlesVisible: false,
    rankDirection: 'LR',
    rankSeparation: 30,
    nodeSeparation: 15,
    defaultWidth: 100,
    defaultHeight: 100,
    minimumWidth: 30,
    minimumHeight: 30,
    edgeType: 'simplebezier',
    markerType: MarkerType.Arrow,
    edgeWidth: 2,
    markerSize: 40,
    defaultIconFill: '#ffffff',
    defaultIconStroke: '#000000',
    defaultTextFill: '#000000',
    defaultTextStroke: '#ffffff',
    minFontSize: 8,
    maxFontSize: 32,
    fontSizeScaleDivisor: 3,
    bold: true,
    upright: true,
    padding: 5,
};
export const EntityNetworkSchematicContextReducer = (state, action) => {
    return { ...state, ...action };
};
export const EntityNetworkSchematicContext = createContext([defaultEntityNetworkSchematicContext, () => { }]);
